import { useState, useEffect } from 'react'
import { Row, Col, Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';

function Newsletter({ status, message, onValidated }) {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');

    useEffect(() => {
        if (status === 'success') clearFields()
    }, [status])

    const handleSubmit = (e) => {
        e.preventDefault();
        email &&
            email.indexOf("@") > -1 &&
            onValidated({
                EMAIL: email
            })
    }

    const clearFields = () => {
        setEmail('');
    }

    return (
        <Col lg={12}>
            <div className="newsletter-bx wow slideInUp" id="newsletter">
                <Row className="align-items-center">
                    <Col lg={12} md={6} xl={5}>
                        <h3>{t('newsletter.title')}</h3>
                        {status === 'sending' && <Alert>{t('newsletter.sending')}</Alert>}
                        {status === 'error' && <Alert variant="danger" dangerouslySetInnerHTML={{ __html: String(message) }} />}
                        {status === 'success' && <Alert variant="success" dangerouslySetInnerHTML={{ __html: String(message) }} />}
                    </Col>
                    <Col md={6} xl={7}>
                        <form onSubmit={handleSubmit}>
                            <div className="new-email-bx">
                                <input className="form-control" value={email} type="email" onChange={(e) => setEmail(e.target.value)} placeholder={t('newsletter.email')} />
                                <button className="new-email-bx-button" type="submit">{t('newsletter.submit')}</button>
                            </div>
                        </form>
                    </Col>
                </Row>
            </div>
        </Col>
    )
}

export default Newsletter